export default __webpack_public_path__ + "static/media/img2.f3a525fb.jpg";